<template>
	<el-row>
		<el-col :span="22">
			圈文目录管理
		</el-col>
		<el-col :span="2">
			<el-button icon="el-icon-plus" type="primary" @click="open(1)" size="mini">添加</el-button>
		</el-col>
		<el-divider></el-divider>
		<el-col :span="24">
			<el-table :data="tableData" row-key="id" border
				:tree-props="{children: 'childList', hasChildren: 'hasChildren'}">
				<el-table-column prop="id" label="id"></el-table-column>
				<el-table-column prop="name" label="名称"></el-table-column>
				<el-table-column prop="introduction" label="简介"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button icon="el-icon-circle-plus-outline" type="success" @click="open(2,scope.row)"
							v-if="scope.row.level !=3">
							添加子级
						</el-button>
						<el-button icon="el-icon-edit-outline" type="warning" @click="open(3,scope.row)">编辑</el-button>
						<el-button icon="el-icon-delete-solid" type="danger" @click="remove(scope.row.id)">删除
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-col>
		<el-dialog :visible.sync="dialogVisible" :title="title" width="30%">
			<el-form label-width="50px" label-position="right">
				<el-form-item label="*名称">
					<el-input v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="简介">
					<el-input v-model="form.introduction" type="textarea"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sumbit()">确 定</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</el-row>
</template>

<script>
	export default {
		data() {
			return {
				dialogVisible: false, //弹出框
				title: '', //弹出框标题
				tableData: [], //表格数据
				num: null, //判断增还是改
				form: { //需要的数据
					id: '',
					parentId: '',
					name: "",
					level: '',
					introduction: ''
				}
			}
		},
		methods: {
			//删除
			remove(id) {
				console.log(id);
				this.$confirm('此操作将永久删除该目录, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post(`/api/plant/groupMaterial/delGroupLibrary`, {
						id: id
					}).then(res => {
						console.log(res.data);
						if (res.data.status == 0) {
							this.$message.success(res.data.data)
							this.getList()
						} else {
							this.$message.error(res.data.msg)
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},

			//打开弹窗
			open(num, row) {
				// num 1添加一级 2添加子级 3编辑 
				console.log(num, row)
				this.dialogVisible = true
				this.num = num
				switch (num) {
					case 1:
						this.title = '添加1级'
						for (var i in this.form) {
							this.form[i] = ''
						}
						this.form.level = 1
						break;
					case 2:
						this.title = `添加${row.name}的子级`
						this.form = {
							id: '',
							parentId: row.id,
							name: "",
							level: row.level - 0 + 1,
							introduction: ''
						}
						break;
					case 3:
						this.title = `编辑${row.name}的子级`
						this.form = {
							id: row.id,
							parentId: row.parentId,
							name: row.name,
							level: row.level,
							introduction: row.introduction
						}
						break;
				}
			},

			//确认按钮
			sumbit() {
				if (this.form.name == '') {
					this.$message.error('请先填写名称')
					return false
				}
				console.log(this.form.id);
				// return false
				// this.num 1添加一级 2添加子级 3编辑 
				if (this.num != 3) {
					//添加提交
					this.audit('insertGroupLibrary')
				} else {
					//编辑提交
					this.audit('updateGroupLibrary')
				}
			},

			//增or改的接口
			audit(url) {
				this.$http.post(`/api/plant/groupMaterial/${url}`, this.form).then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.success(res.data.data)
						this.dialogVisible = false
						this.getList()
					} else {
						this.$message.error(res.data.msg)
					}
				})
			},

			//获取列表
			getList() {
				this.$http.post('/api/plant/groupMaterial/selectGroupLibrary', {}).then(res => {
					console.log(res.data.data);
					if (res.data.status == 0) {
						this.tableData = res.data.data
					} else {
						this.$message.error('发生了一些错误')
					}
				}).catch(err => {
					this.$message.error('发生了一些错误', err)
				})
			},
		},
		created() {
			this.getList()
		}
	}
</script>

<style scoped>

</style>
